import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { get } from 'lodash';
import { combineLatest, map, Observable } from 'rxjs';
import { TaskWorkspaceStore } from '../../core/h3ml/state/task-workspace-store';
import { Step } from '../../team-apis/otterdam/step';
import { User } from '../../team-apis/otterdam/user';

@Component({
  selector: 'h3-agents-per-step',
  templateUrl: './agents-per-step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AgentsPerStepComponent {
  submittersPerStep$: Observable<Array<{ submitter: User; step: Step }>>;

  constructor(taskWorkspaceStore: TaskWorkspaceStore) {
    const steps$ = taskWorkspaceStore('project')('steps').$;
    const submitters$ = taskWorkspaceStore('task')('_extras')('submitters').$;
    this.submittersPerStep$ = combineLatest([steps$, submitters$]).pipe(
      map(([steps, submitters]) =>
        steps
          .filter((step) => isDefined(get(submitters, step.id)))
          .map((step) => ({ step, submitter: submitters![step.id] })),
      ),
    );
  }
}
